var map = {
	"./Bed Room Panel.jpeg": 934,
	"./Living Room Panel.jpeg": 5696,
	"./Marble Golw Estates.jpeg": 9799,
	"./Matt Finish Wall Panel.jpeg": 4383,
	"./Textured Wall Panel.jpeg": 5503,
	"./UV Sheet Design.jpeg": 5812,
	"./Wall panel.jpeg": 6388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6837;